export default __webpack_public_path__ + "static/media/demo-02.9bb6d63d.gif";